document.addEventListener("DOMContentLoaded", function() {
  // Define sales rep variables
   /*sales rep variables*/
   var hKAustralia = {
    "title": "Wendy Simpson",
    "addrLine1": "P.O. Box 913, Mitcham",
    "addrLine2": "South Australia 5062",
    "addrLine3": "",
    "addrLine4": "",
    "phone"    : "0408 734 123",
    "email1"   : "wendysimpson@human-kinetics.co.uk",
    "email2"   : "",
    "misc"     : "Website: Ebooks can be purchased separately from VitalSource and at Human Kinetics’ US store: <a href='https://us.humankinetics.com/'>https://us.humankinetics.com/</a>",
    "trade"    : ""
  };

var hKUsa = {"title": "Human Kinetics - USA, Ltd.",
       "addrLine1": "1607 N. Market Street",
       "addrLine2": "",
       "addrLine3": "Champaign, IL 61820",
               "addrLine4": "",
       "phone"    : "800-747-4457",
       "fax"      : "217-351-1549",
              "email1"    : "CustomerSupport@hkusa.com",
               "email2"   : "",
               "trade"    : ""
  };

var hKEurope = {"title": "Mare Nostrum Group",
       "addrLine1": "39 East Parade",
       "addrLine2": "Harrogate",
       "addrLine3": "North Yorkshire, HG1 5LQ England",
               "addrLine4":"",
       "phone"    : "01423562232",
       "fax"      : "",
               "email1"   : "contact@human-kinetics.co.uk",
               "email2"   : "",
               "trade"    : ""
   };

var hKIndia = {"title": "Mare Nostrum Group",
       "addrLine1": "39 East Parade",
       "addrLine2": "Harrogate",
       "addrLine3": "North Yorkshire, HG1 5LQ England",
               "addrLine4":"",
       "phone"    : "01423562232",
       "fax"      : "",
               "email1"   : "contact@human-kinetics.co.uk",
               "email2"   : "",
               "trade"    : ""
   };
 
var cranburyInternational={
               "title": "Cranbury International LLC",
       "addrLine1": "7 Clarendon Ave.",
       "addrLine2": "Montpelier, VT 05602 USA",
       "addrLine3": "",
               "addrLine4":"",
       "phone"    : "802-223-6565",
       "fax"      : "802-223-6824",
       "email1"   : "eatkin@cranburyinternational.com",
               "email2"   : "",
               "trade"    : ""
};

var johnAtkin={
    "title"    : "Sales Rep:",
    "addrLine1": "John Atkin",
    "addrLine2": "",
    "addrLine3": "",
            "addrLine4":"",
    "phone"    : "203-451-2396",
    "fax"      : "",
    "email1"   : "jatkin@silvermineinternational.com",
            "email2"   : "",
            "trade"    : ""
        
};

var joseRios={
    "title"    : "Sales Rep:",
    "addrLine1": "Mr. Jose Rios",
    "addrLine2": "",
    "addrLine3": "",
            "addrLine4":"",
    "phone"    : "502-907-2434",
    "fax"      : "502-907-2434",
    "email1"   : "joserios@sover.net",
            "email2"   : "",
            "trade"    : ""
};

var internationalPublishingServices ={
    "title": "International Publishing Services Ltd. (IPS ME)",
    "addrLine1": "Mr. Unni Krishnan",
    "addrLine2": "PO Box 27533",
    "addrLine3": "Dubai, United Arab Emirates",
            "addrLine4":"",
    "phone"    : "+971 (4) 23 84 001",
    "fax"      : "",
    "email1"   : "books@ipsme.ae",
            "email2"    : "",
            "trade": "",
            
};

var africaConnection ={
    "title": "Africa Connection, Old School House,",
    "addrLine1" : "Wallingford Road, Mongewell, Wallingford, OX10 8DY",
    "addrLine2" : "Office: 01491 - 837028, Mobile 07808-522886 ",
    "addrLine3" : "",
            "addrLine4" : "",
    "phone"     : "",
    "fax"       : "",
    "email1"    : "guy.simpson@africaconnection.co.uk",
            "email2"    : "",
            "trade": ""
};

var laszloHorvath= {
    "title": "Laszlo Horvath",
    "addrLine1": "Tinódi u. 31.",
    "addrLine2": "1047 Budapest",
    "addrLine3": "Hungary",
            "addrLine4":"",
    "phone": "36 1 3703614",
    "fax": "36 1 3795842",
    "email1": "booksforeeurope@gmail.com",
            "email2"    : "",
            "trade": ""
};

var laszloHorvathAcademic= {
    "title": "Laszlo Horvath",
    "addrLine1": "Tinódi u. 31.",
    "addrLine2": "1047 Budapest",
    "addrLine3": "Hungary",
            "addrLine4":"",
    "phone": "36 1 3703614",
    "fax": "36 1 3795842",
    "email1": "booksforeeurope@gmail.com",
            "email2"    : "",
            "trade": "Academic Only"
};

var renatoReichmann={
    "title": "Sales Rep:",
    "addrLine1": "Renato Reichmann",
    "addrLine2": "",
    "addrLine3": "",
            "addrLine4":"",
    "phone": "(55)(11)3032-2175",
    "fax": "",
    "email1": "rrr@erdl.com.br",
            "email2"    : "",
            "trade": ""
};

var alkemCompany ={
     "title"    : "Alkem Company (S) Pte. Ltd.",
 "addrLine1": "No. 1, Penjuru Close, Singapore 608617",
 "addrLine2": "Adrian Tan / Melvin Choo(Indone.)",
 "addrLine3": "",
     "addrLine4":"",
 "phone"    : "(65) 2656666",
 "fax"      : "(65) 2617875",
 "email1"   : "adrian@alkem.com.sg",
     "email2"   : "melvinchoo@alkem.com.sg",
     "trade"    : ""
  };

var bookportAssociates ={
     "title"    : "Bookport Associates",
 "addrLine1": "Via Luigi Salma 7",
 "addrLine2": "Corsica MI, I-20094",
 "addrLine3": "Italy",
     "addrLine4":"",
 "phone"    : "39 02 4510 3601",
 "fax"      : "39 02 4510 6426",
 "email1"   : "bookport@bookport.it",
     "email2"   : "",
     "trade"    : "Trade Only"
  };
  
var MarcelloSas ={
     "title"     : "Marcello s.a.s",
   "addrLine1" : "Via Belzoni 12",
 "addrLine2" : "Padova, I-35121",
 "addrLine3" : "Italy",
     "addrLine4" : "",
 "phone"     : "0498360671",
 "fax"       : "498786759",
 "email1"    : "marcello@marcellosas.it",
     "email2"    : "",
     "trade"     : "Academic Only"
};

var chinaPublishers ={
     "title"     : "China Publishers Services Ltd",
   "addrLine1" : "Room 502, Door 3, Building 211",
 "addrLine2" : "Hua Jia Di Xi Li, Chaoyang District",
 "addrLine3" : "100102 Beijing China",
     "addrLine4" : "",
 "phone"     : "",
 "fax"       : "",
 "email1"    : "",
     "email2"    : "",
     "trade"     : "<strong>MARKETING REPRESENTATIVE</strong>"
};
  
var benBai ={
     "title"     : "Ben Bai (China)",
   "addrLine1" : "18910752902",
 "addrLine2" : "",
 "addrLine3" : "",
     "addrLine4" : "",
 "phone"     : "",
 "fax"       : "",
 "email1"    : "benbai@cps-hk.com",
     "email2"    : "",
     "trade"     : "",
     "misc"      : "Website: <a href='http://www.cps-hk.com/'>www.cps-hk.com</a>"
};

var kinesWorld ={
     "title"     : "KinesWorld ",
   "addrLine1" : "Room 518, Building No. 3",
 "addrLine2" : "25 Sanjing World Science Tech Park",
 "addrLine3" : "North Changjiang Road, Xingbei District",
     "addrLine4" : "Changzhou, Jiangsu China 213000 ",
 "phone"     : "",
 "fax"       : "",
 "email1"    : "",
     "email2"    : "",
     "trade"     : "<strong>DISTRIBUTION</strong>"
};

var enyiCai ={
     "title"     : "Enyi Cai",
   "addrLine1" : "021-63060640",
 "addrLine2" : "",
 "addrLine3" : "",
     "addrLine4" : "",
 "phone"     : "",
 "fax"       : "",
 "email1"    : "kinesworld@gmail.com",
     "email2"    : "",
     "trade"     : "",
     "misc"      : "Website: <a href='http://www.kinesworld.net/'>www.kinesworld.net</a>"
};

var crwMarketing ={
     "title"     : "CRW Marketing Services for Publishers, Inc",
   "addrLine1" : "15 Pearl Avenue, Greenheights",
 "addrLine2" : "Taytay, Rizal, Philippines 1920",
 "addrLine3" : "",
     "addrLine4" : "",
 "phone"     : "",
 "fax"       : "",
 "email1"    : "",
     "email2"    : "",
     "trade"     : "",
     "misc"      : ""
};

var tonySagun ={
     "title"     : "Tony Sagun",
   "addrLine1" : "",
 "addrLine2" : "",
 "addrLine3" : "",
     "addrLine4" : "",
 "phone"     : "(632) 660-5480",
 "fax"       : "",
 "email1"    : "crwmarketing@pldtdsl.net",
     "email2"    : "",
     "trade"     : "",
     "misc"      : ""
};

var kemperConseil = {
     "title": "Kemper Conseil Publishing",
 "addrLine1":"Dineke & Enno Kemper",
 "addrLine2":"Schuifmaat 14 Unit GH",
 "addrLine3":"NL-2495 AM DEN HAAG",
     "addrLine4":"Netherlands",
 "phone"    : "31 - 70 386 80 31",
 "fax"      : "",
 "email1"   : "info@kemperconseil.nl",
     "email2"   : "",
     "trade"    : ""
  };
  
var theWhitePartnership ={
     "title"     : "The White Partnership",
   "addrLine1" : "6 Newlands road",
 "addrLine2" : "Kent, TN4 9AT, United KingdomTunbridge Wells",
 "addrLine3" : "",
     "addrLine4" : "Andrew White",
 "phone"     : "+44 (0) 1892 557767",
 "fax"       : "",
 "email1"    : "andrew@thewhitepartnership.org.uk",
     "email2"    : "",
     "trade"     : "",
     "misc"      : ""
};

var rennicsBookshop ={
     "title"     : "Rennics Bookshop Co. Ltd",
   "addrLine1" : "Mr. Ayush Aggarwal",
 "addrLine2" : "P.O. Box 7775, Sokoine Road",
 "addrLine3" : "Moshi, Tanzania",
     "addrLine4" : "",
 "phone"     : "+91 99107 94400 <br>+255 784618890",
 "fax"       : "",
 "email1"    : "rennicbookshop@gmail.com",
     "email2"    : "",
     "trade"     : "",
     "misc"      : ""
};

var iconBooksSingapore ={
     "title"     : "Icon Books Singapore Pte Ltd",
   "addrLine1" : "3 Pemimpin Drive #8-04",
 "addrLine2" : "Lip Hing Industrial Building",
 "addrLine3" : "Singapore 576147",
     "addrLine4" : "Melvin Yo",
 "phone"     : "(65) 6256-7353",
 "fax"       : "(65) 62892042 ",
 "email1"    : "melvin.yo@icon.com.sg",
     "email2"    : "",
     "trade"     : "",
     "misc"      : ""
};

var latinflyLlc ={
     "title"     : "Latinfly, LLC",
   "addrLine1" : "Enrique Gallego",
 "addrLine2" : "",
 "addrLine3" : "",
     "addrLine4" : "",
 "phone"     : "",
 "fax"       : "",
 "email1"    : "egallego@latin-fly.com",
     "email2"    : "",
     "trade"     : "",
     "misc"      : ""
};

   /*Json array that contains all the countries and sales reps*/
   var countryArray=[
    {
      "Albania": [
            hKEurope
      ]
    },{
      "Algeria": [
        internationalPublishingServices
      ]
    },{
      "Andorra": [
        hKEurope
      ]
    },{
      "Angola": [
              hKEurope
      ]
    },{
      "Anguilla": [
            
        hKUsa,
              
      ]
    },{
      "Antigua": [
            
        hKUsa
      ]
    },{
      "Argentina": [
            
               latinflyLlc
              
      ]
    },
        {
      "Armenia": [
        hKEurope
      ]
    },{
      "Aruba": [
        hKUsa
      ]
    },{
         "Australia": [
           hKAustralia
          ]
    },{
          "Austria": [
            hKEurope
          ]
    },{
          "Azerbaijan": [
            hKEurope
          ]
    },{
          "Bahamas": [
           latinflyLlc
          ]
    },{
          "Bahrain": [
           hKEurope
          ]
    },{
        "Balearics": [
           hKEurope
          ]
    },{
        "Bangladesh": [
          alkemCompany
          ]
    },{
          "Barbados": [
           latinflyLlc
          ]
    },{
          "Barbuda": [
           hKUsa
          ]
    },{
          "Belarus": [
           hKEurope
          ]
    },{
        "Belgium": [
          hKEurope
          ]
    },{
          "Belize": [
           latinflyLlc
           
          ]
    },{
          "Benin": [
           hKEurope
          ]
    },{
          "Bermuda": [
           latinflyLlc
          ]
    },{
          "Bolivia": [
           latinflyLlc
         
          ]
    },{
          "Bonaire": [
           hKUsa
          ]
    },{
      "Bosnia": [
        hKEurope
        ]
    },{
      "Botswana": [
        hKEurope
      ]
    },{
      "Brazil": [
         latinflyLlc
      ]
    },{
      "British Virgin Islands": [
        hKUsa
      ]
    },{
      "Brunei": [
        alkemCompany
      ]
    },{
      "Bulgaria": [
        hKEurope
      ]
    },{
      "Burkina Faso": [
        hKEurope
      ]
    },{
      "Burundi": [
        hKEurope
      ]
    },{
      "Caicos Islands": [
        hKUsa
      ]
    },{
      "Cameroon": [
        hKEurope
      ]
    },{
      "Canada": [
        {"title": "Login Brothers Canada",
             "addrLine1": "300 Saulteaux Crescent",
             "addrLine2": "Winnipeg, MB R3J 3T2",
             "addrLine3": "",
              "addrLine4":"",
             "phone"    : "(800) 665-1148",
             "fax"      : "",
                     "email1"   : "custserv@lb.ca",
                     "email2"   : "",
                     "trade"    : "",
                     "misc"     : ""
              }
      ]
    },{
      "Canary Island": [
             hKEurope
      ]
    },{
      "CapeVerde": [
        hKEurope
      ]
    },{
      "Caribbean": [
        latinflyLlc
      ]
    },{
      "Cayman Islands": [
        hKUsa
      ]
    },{
      "Central African Republic": [
        hKEurope
      ]
    },{
      "Chad": [
        hKEurope
      ]
    },{
      "Chile": [
        latinflyLlc
      ]
    },{
      "China": [
        chinaPublishers,
              benBai
      ]
    },{
      "Colombia": [
             latinflyLlc
      ]
    },{
      "Comoros": [
            hKEurope
      ]
    },{
      "Congo": [
            hKEurope
      ]
    },{
      "Cook Islands": [
              hKAustralia
      ]
    },{
      "Costa Rica": [
              latinflyLlc
      ]
    },{
      "Croatia": [
            hKEurope
      ]
    },{
          "Cuba": [
           hKUsa
          ]
    },{
          "Curaçao": [
           hKUsa
          ]
    },{
      "Cyprus": [
        hKEurope
      ]
    },{
      "Czech Republic": [
        hKEurope
      ]
    },{
      "Denmark": [
        hKEurope
      ]
    },{
      "Djibouti": [
        hKEurope
      ]
    },{
          "Dominica": [
           hKUsa
          ]
    },{
          "Dominican Republic": [
           hKUsa
          ]
    },{
          "EARCOS Schools": [
           crwMarketing,
           tonySagun
          ]
    },{
          "Ecuador": [
           latinflyLlc
          ]
    },{
          "Egypt": [
          hKEurope
          ]
    },{
          "El Salvador": [
           latinflyLlc
          ]
    },{
          "Estonia": [
           hKEurope
          ]
    },{
          "Ethiopia": [
            
            hKEurope
          ]
    },{
      "Equitorial Guinea": [
        hKEurope
      ]
      },{
          "Fiji": [
        hKAustralia
          ]
      },{
          "France": [
      hKEurope
          ]
    },{
          "French Guiana": [
      latinflyLlc
          ]
    },{
          "French Polynesia": [
      hKAustralia
          ]
    },{
          "Gabon": [
      hKEurope
          ]
    },{
          "Gambia": [
      hKEurope
          ]
    },{
          "Georgia": [
      hKEurope
          ]
    },{
          "Germany": [
      hKEurope
          ]
    },{
          "Ghana": [
      hKEurope
          ]
    },{
          "Gibraltar": [
      hKEurope
          ]
    },{
          "Greece": [
      hKEurope
          ]
    },{
          "Grenada": [
           hKUsa
          ]
    },{
          "The Grenadines": [
           hKUsa
          ]
    },{
          "Guadeloupe": [
           hKUsa
          ]
    },{
          "Guatemala": [
           latinflyLlc
          ]
    },{
          "Guinea": [
      hKEurope
          ]
    },{
          "Guinea Bissau": [
      hKEurope
          ]
    },{
          "Guyana": [
      latinflyLlc
          ]
    },{
          "Haiti": [
           hKUsa
          ]
    },{
          "Herzegovina": [
           hKEurope
          ]
    },{
          "Honduras": [
           latinflyLlc
          ]
    },{
          "Hong Kong": [
           {
              "title"     : "China Publishers Services Ltd",
            "addrLine1" : "Room 718 Fortune Commercial Building",
          "addrLine2" : "362 Sha Tsui Road, Tsuen Wan, N.T.",
          "addrLine3" : "Hong Kong SAR",
              "addrLine4" : "",
          "phone"     : "",
          "fax"       : "",
          "email1"    : "",
              "email2"    : "",
              "trade"     : ""
           },{
              "title"     : "Edwin Chu (Hong Kong)",
            "addrLine1" : "(852) 2491 1436",
          "addrLine2" : "",
          "addrLine3" : "",
              "addrLine4" : "",
          "phone"     : "",
          "fax"       : "",
          "email1"    : "edwin@cps-hk.com",
              "email2"    : "",
              "trade"     : "",
              "misc"      : "Website: <a href='http://www.cps-hk.com/'>www.cps-hk.com</a>"
          }
           
          ]
    },{
          "Hungary": [
           hKEurope
          ]
    },{
          "Iceland": [
           hKEurope
          ]
    },{
          "India": [
           hKIndia
          ]
      },{
             
          "Indonesia": [
           theWhitePartnership
          ]
    },{
          "Iran": [
           
      hKEurope
        
          ]
    },{
          "Iraq": [
           hKEurope 
          ]
    },{
          "Ireland": [
           hKEurope 
          ]
    },{
          "Israel": [
           hKEurope
          ]
    },{
          "Italy": [
           hKEurope
          ]
    },{
          "Ivory Coast": [
           hKEurope
          ]
    }, {
      "Jamaica": [
       latinflyLlc
      ]
    },{
      "Japan": [
        {
          "description"    : "For customers wishing to place an order, please contact our non-exclusive, local distributor in Japan:",
          "title"     : "Maruzen-Yushodo",
          "addrLine1" : "Academic Information Solutions Division",
          "addrLine2" : "Tokyo Dia Blg #5-10F,",
          "addrLine3" : "1-28-23 Shinkawa Chouo-ku,",
                  "addrLine4" : "Tokyo, JAPAN",
          "phone"     : "",
          "fax"       : "",         
          "email1"    : " marketing@maruzen.co.jp<mailto:marketing@maruzen.co.jp>",
                  "email2"    : "",
                  "trade"     : "",
                  "misc"     : "Website: <a href='http://kw.maruzen.co.jp'>kw.maruzen.co.jp</a>",
        },
        {
          "description"    : "For distributors and retailers wishing to sell Human Kinetics products, please contact our agent in Japan:",
          "title"     : "Eureka Press",
          "addrLine1" : "22-3 Higahi-Hiraicho Kita-Shirakawa Sakyo-ku",
          "addrLine2" : "Kyoto,",
          "addrLine3" : "JAPAN",
          "addrLine4" : "",
          "phone"    : "+81 75 741 6631",
          "fax"       : "",
          "email1"    : "ky6844@celery.ocn.ne.jp<mailto:ky6844@celery.ocn.ne.jp>",
                  "email2"    : "",
                  "trade"     : ""
        }
      ]
    },{
          "Jordan": [
           hKEurope
          ]
    },{
          "Kazakhstan": [
           hKEurope
          ]
    },{
      "Kenya": [
         hKEurope
      ]
    },{
      "Korea": [
        {
          "title"     : "ChongHo Ra",
          "addrLine1" : "Impact Korea",
          "addrLine2" : "Suite 715, Shinhan Nextel,",
          "addrLine3" : "14 Dosun-Dong, Sungdong-Gu,",
                  "addrLine4" : "Seoul 133-714, Korea",
          "phone"     : "+82-2-2296-0140",
          "fax"       : "+82-2-2296-0143",
          "email1"    : "impact-kr@naver.com",
                  "email2"    : "",
                  "trade"     : ""
        }
      ]
    },{
          "Kuwait": [
           hKEurope 
          ]
    },{
          "Latvia": [
           hKEurope
          ]
    },{
          "Laos": [
           alkemCompany
          ]
    },{
          "Lebanon": [
            hKEurope
          ]
    },{
          "Lesotho": [
           hKEurope
          ]
    },{
          "Libya": [
            hKEurope 
          ]
    },{
          "Liberia": [
            hKEurope
          ]
    },{
          "Liechtenstein": [
            hKEurope
          ]
    },{
          "Lithuania": [
            hKEurope
          ]
    },{
          "Luxembourg": [
            hKEurope
          ]
    },{
          "Macau": [
            chinaPublishers,
            benBai
          ]
    },{
          "Macedonia": [
           hKEurope
          ]
    },{
          "Madagascar": [
           hKEurope
          ]
    },{
          "Malawi": [
           hKEurope
          ]
    },{
          "Malaysia": [
          alkemCompany
          ]
    },{
          "Mali": [
           hKEurope
          ]
    },{
          "Malta": [
           hKEurope
          ]
    },{
          "Mauritania": [
           hKEurope
          ]
    },{
          "Mauritius": [
           hKEurope
          ]
    },{
          "Mexico": [
           latinflyLlc
          ]
    },{
          "Micronesia": [
           hKAustralia
          ]
    },{
          "Moldova": [
           hKEurope
          ]
    },{
          "Monaco": [
           hKEurope
          ]
    },{
          "Montenegro": [
           hKEurope
        ]
    },{
          "Morocco": [
          hKEurope
        ]
    },{
          "Mozambique": [
           hKEurope
        ]
    },{
          "Namibia": [
           hKEurope
        ]
    },{
          "Netherlands": [
           hKEurope 
        ]
    },{
          "New Zealand": [
           hKAustralia
        ]
    },{
          "Nicaragua": [
           latinflyLlc
        ]
    },{
          "Niger": [
           hKEurope
        ]
    },{
          "Nigeria": [
           hKEurope
        ]
    },{
          "Norway": [
           hKEurope
        ]
    },{
          "Oman": [
           hKEurope
        ]
    },{
          "Panama": [
           latinflyLlc
        ]
    },{
          "Pakistan": [
           hKEurope
        ]
    },{
          "Paraguay": [
           latinflyLlc
        ]
    },{
          "Peru": [
           latinflyLlc
        ]
    },{
          "Philippines": [
           crwMarketing,
           tonySagun
        ]
    },{
          "Poland": [
           hKEurope
        ]
    },{
          "Portugal": [
          hKEurope
        ]
    },{
          "Puerto Rico": [
           latinflyLlc
        ]
    },{
          "Qatar": [
           hKEurope
        ]
    },{
          "Romania": [
           hKEurope
        ]
    },{
          "Russia": [
           hKEurope
        ]
    },{
          "Rwanda": [
           hKEurope
        ]
    },{
          "St Martin": [
           hKUsa
        ]
    },{
          "Saint Marten": [
           hKUsa
        ]
    },{
          "Sao Tome and Principe": [
           hKEurope
        ]
    },{
          "St Vincent": [
           hKUsa
        ]
    },{
          "Saipan": [
           crwMarketing,
           tonySagun
        ]
    },{
          "San Marino": [
           hKEurope
        ]
    },{
          "Saudi Arabia": [
           hKEurope
        ]
    },{
          "Senegal": [
           hKEurope
        ]
    },{
          "Serbia": [
           hKEurope
        ]
    },{
          "Sierra Leone": [
           hKEurope
        ]
    },{
          "Singapore": [
           alkemCompany
        ]
    },{
          "Slovakia": [
           hKEurope
        ]
    },{
          "Slovenia": [
            hKEurope
        ]
    },{
          "Somalia": [
           hKEurope
        ]
    },{
          "South Africa": [
           {
          "title"     : "Academic and Professional Book Distributors",
          "addrLine1" : "2 Robant Lane",
          "addrLine2" : "Rivonia 2128",
          "addrLine3" : "Gautang Province",
                  "addrLine4" : "South Africa <br>Contact: Michelle Woodrow",
          "phone"     : "(27) 11 803 6000",
          "fax"       : "",
          "email1"    : "woodrow@yebo.co.za",
                  "email2"    : "",
                  "trade"     : ""
          }
        ]
    },{
          "Spain": [
           hKEurope
        ]
    },{
          "Sri Lanka": [
           hKIndia
        ]
    },{
          "Sudan": [
            hKEurope
        ]
    },{
          "Suriname": [
            latinflyLlc
        ]
    },{
          "Sweden": [
           hKEurope
        ]
    },{
          "Swaziland": [
           hKEurope
        ]
    },{
          "Switzerland": [
           hKEurope 
        ]
    },{
          "Syria": [
            hKEurope
        ]
    },{
          "Taiwan": [
            {
          "title"     : "Unifacmanu Trading Co., Ltd.",
          "addrLine1" : "4F, 91, Ho-Ping",
          "addrLine2" : "East Road Sec. 1",
          "addrLine3" : "Taipei 10609 R.O.C.",
                  "addrLine4" : "Nancy Lin",
          "phone"     : "(886) 2-23419646",
          "fax"       : "(886) 2-23943103",
          "email1"    : "winjoin@ms12.hinet.net",
                  "email2"    : "",
                  "trade"     : ""
          }
        ]
    },{
          "Tanzania": [
             hKEurope
        ]
    }, {
          "Thailand": [
            theWhitePartnership 
        ]
    },{
          "Tobago": [
          latinflyLlc
        ]
    },{
          "Togo": [
             hKEurope
        ]
    },{
          "Tonga": [
            hKAustralia
        ]
    },{
          "Trinidad": [
            latinflyLlc
        ]
    },{
          "Tunisia": [
            hKEurope
        ]
    },{
          "Turks Islands": [
            hKUsa
        ]
    },{
          "Turkey": [
            hKEurope
        ]
    },{
          "Uganda": [
            hKEurope
        ]
    },{
          "Ukraine": [
            hKEurope
        ]
    },{
          "Upper Volta": [
            hKEurope
        ]
    },{
          "United Arab Emirates": [
            hKEurope
        ]
    },{
          "United Kingdom": [
            hKEurope
        ]
    },{
          "Uruguay": [
            latinflyLlc
        ]
    },{
          "US Virgin Islands": [
            latinflyLlc
        ]
    },{
          "Venezuela": [
            latinflyLlc
        ]
    },{
          "Viet Nam": [
            alkemCompany
        ]
    },{
          "West Bank": [
            hKEurope 
        ]
    },{
          "Yemen": [
            hKEurope
        ]
    },{
          "Zambia": [
            hKEurope 
        ]
    },{
          "Zaire": [
            hKEurope
        ]
    },{
          "Zimbabwe": [
            hKEurope 
        ]
    }
  ];

  function populateDropdown() {
      var dropDownCountry = document.getElementById("dropDownCountry");
      countryArray.forEach(function(countries) {
        for (var country in countries) {
          var salesReps = countries[country];
          var option = document.createElement("option");
          option.value = country;
          option.setAttribute("data-salesRep", JSON.stringify(salesReps));
          option.innerHTML = country;
          dropDownCountry.appendChild(option);
        }
      });
    }

    function getSalesRepDets(dataArray, country) {
      var dets = '';
      dataArray.forEach(function(value) {
        dets += "<div class='col-md-6'>";
        dets += "<p class='salesRepTitle'><strong>" + country + "</strong></p>";
        if(value.trade !==''){
            dets += "<p class='sale-rep-trade'><strong>"+ value.trade + "</strong></p>";
          }
          //Start HK code: added custom code to display description if it exist
          if (value.description != undefined && value.description != ''){
            dets += "<p>" + value.description + "<p>";
          }
          //End HK code
          if(value.title !==''){
            dets += "<p class='sale-rep'>"+ value.title + "<br>";
          }
          if(value.addrLine1 !==''){
            dets += value.addrLine1 + "<br>";
          }
          if(value.addrLine2 !==''){
            dets += value.addrLine2 + "<br>";
          }
          if(value.addrLine3 !==''){
            dets += value.addrLine3 + "<br>";
          }
          if(value.addrLine4 !==''){
            dets += value.addrLine4 + "<br>";
          }
          if(value.phone !==''){
            dets += "Telephone: "+ value.phone + "<br>";
          }
          if(value.fax !==''){
            dets += "Fax: "+ value.fax + "<br>";
          }
          if(value.email1 !==''){
             dets += "Email: <a href='mailto:"+value.email1+"' target='_top'>"+value.email1+"</a><br>";
          }
          if(value.email2 !==''){
             dets += "<a href='mailto:"+value.email2+"' target='_top'>"+value.email2+"</a><br>";
          }
          if(value.misc!=undefined && value.misc !==''){
             dets += value.misc ;
          }
        dets += "</div>";
      });
      return dets;
    }

    var dropDownCountry = document.getElementById("dropDownCountry");
    var salesRepElement = document.getElementById("salesRep");
    var showAllSalesRepsButton = document.getElementById("showAllSalesReps");

    populateDropdown();

    dropDownCountry.addEventListener("change", function() {
      var selectedOption = dropDownCountry.options[dropDownCountry.selectedIndex];
      var salesReps = selectedOption.getAttribute("data-salesRep");
      var dataArray = JSON.parse(salesReps);
      var selectedCountry = selectedOption.text;
      var dets = getSalesRepDets(dataArray, selectedCountry);
      showingAll = 0;
      salesRepElement.innerHTML = dets.trim();
    });

    var showingAll = 0;
    showAllSalesRepsButton.addEventListener("click", function() {
      var dets = '';
      dropDownCountry.value = "";

      if (showingAll === 0) {
        countryArray.forEach(function(countries) {
          for (var country in countries) {
            var dataArray = countries[country];
            dets += getSalesRepDets(dataArray, country);
          }
        });
        salesRepElement.innerHTML = dets.trim();
        showingAll = 1;
      } else {
        salesRepElement.innerHTML = '';
        dropDownCountry.focus();
        showingAll = 0;
      }
    });
});
